var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackInstaBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Slider"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53564 2.6557C2.53564 2.23801 2.87424 1.89941 3.29193 1.89941H15.3925C15.8102 1.89941 16.1488 2.23801 16.1488 2.6557V16.2688C16.1488 16.5708 15.9691 16.8439 15.6917 16.9634C15.4144 17.0829 15.0925 17.0259 14.873 16.8185L9.3422 11.5919L3.81137 16.8185C3.59187 17.0259 3.27002 17.0829 2.99266 16.9634C2.71531 16.8439 2.53564 16.5708 2.53564 16.2688V2.6557ZM4.04821 3.41198V14.5136L8.82276 10.0016C9.11427 9.72615 9.57013 9.72615 9.86165 10.0016L14.6362 14.5136V3.41198H4.04821Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackInstaBookmark);
export default __webpack_public_path__ + "static/media/black-insta-bookmark.6854d5f07bb4a3b52cb88f9bdd59ade6.svg";
export { ForwardRef as ReactComponent };